import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import ModuleVersionInstructionsDrawerContent from "views/Account/Module/Version/components/InstructionsDrawer/Content";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { Module } from "types/generated";

type ModuleVersionInstructionsDrawerProps = {
  module: Module;
};

const ModuleVersionInstructionsDrawer = createDrawer(
  ({ module }: ModuleVersionInstructionsDrawerProps) => {
    return (
      <DrawerSimple variant="wide">
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Instructions" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          {module.current && (
            <ModuleVersionInstructionsDrawerContent
              inputs={module.current.metadata?.root.inputs}
              moduleName={module.name}
              type="module"
              versionNumber={module.current.number}
              moduleSource={module.moduleSource}
              workflowTool={module.workflowTool}
            />
          )}
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showModuleVersionInstructionsDrawer = createDrawerTrigger(
  ModuleVersionInstructionsDrawer
);
